require('./bootstrap');
require('./polyfills');
require('./vendor/fontawesome-all.min');

import Vue from 'vue';

import VeeValidateNl from 'vee-validate/dist/locale/nl';
import VeeValidate from 'vee-validate';

Vue.use(VeeValidate, {
  locale: 'nl',
  dictionary: {
    nl: {
      messages: VeeValidateNl.messages,
    },
  },
});

Vue.component('spotlight', () => import('./components/parts/spotlight.vue'));
Vue.component('image-slider', () => import('./components/parts/image-slider.vue'));
Vue.component('mobile-slider', () => import('./components/parts/mobile-slider.vue'));
Vue.component('contact-form', () => import('./components/forms/contact.vue'));
Vue.component('download-doc-form', () => import('./components/forms/download-doc.vue'));
Vue.component('conditional-video', () => import('./components/parts/conditional-video.vue'));

/**
 * Slugify a given text string
 * The text will be set to lowercase and all spaces
 * will be replaced with '-' signs
 */
Vue.prototype.slugMe = function(text) {
  if (!text) return '';

  let slug = text.replace(/^\s+|\s+$/g, '').toLowerCase();
  let from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;';
  let to = 'aaaaeeeeiiiioooouuuunc------';

  for (let i = 0, l = from.length; i < l; i++) {
    slug = slug.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
  }

  slug = slug
    .replace(/[^a-z0-9 -]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');

  return slug;
};

/**
 * Handle server errrors
 * - If validation error show an array of validation errors
 * - If exception show the exception message in the array
 * - If anything else show the message 'Something went wrong'
 */
window.handleError = function(error) {
  if (error.response.data.error) return error.response.data.error;
  else if (error.response.data.exception) return [[error.response.data.message]];
  else return [['Something went wrong.']];
};

/**
 * Handle server success messages
 */
window.handleSuccess = function(success) {
  if (success.data.success) return success.data.data.message;
  else return [['Success.']];
};

/**
 * Get route params
 * search all route params and
 * push them on an array [ name : value ]
 */
window.getParam = function(name) {
  let result = '';
  let tmp = [];
  let items = location.search.substr(1).split('&');

  for (let i = 0; i < items.length; i++) {
    tmp = items[i].split('=');
    if (tmp[0] === name) result = decodeURIComponent(tmp[1]);
  }

  return result;
};

Vue.prototype.formatPriceLabel = function(price, currency, purposeStatusId, purposeId) {
  if (!purposeStatusId) return '';

  if (purposeStatusId === 3) return 'Verkocht!';

  if (purposeStatusId === 4) return 'Verhuurd!';

  if (parseInt(price) < 2) return 'Prijs op aanvraag';

  if (purposeStatusId === 1 || purposeStatusId === 2 || purposeStatusId === 5 || purposeStatusId === 6 ) {
    if (!price) return '';
    
    price = `${price}`.replace(/,/g, '.');

    const status = (purposeId === 2 || purposeStatusId === 6) ? '/ maand' : '';
    const formattedPrice = Number(price).toLocaleString('nl-BE', { minimumFractionDigits: 2 });
    return `${currency} ${formattedPrice} ${status}`;
  }

  return 'Prijs overeen te komen';
};

import SvgVue from 'svg-vue';
Vue.use(SvgVue);

import AOS from 'aos';
import 'aos/dist/aos.css';

import route from 'ziggy';
import { Ziggy } from './ziggy';

Vue.mixin({
  methods: {
    route: (name, params, absolute) => route(name, params, absolute, Ziggy),
  },
});
//php artisan ziggy:generate "resources/js-projects/ziggy.js"

$(window).scroll(function() {
  if (!$('header').hasClass('fixed')) {
    var scroll = $(window).scrollTop();
    if (scroll > 50) {
      $('header').addClass('white');
    } else {
      $('header').removeClass('white');
    }
  }
});

AOS.init({
  offset: 100,
  duration: 700,
  once: true,
  disable: 'mobile',
});

new Vue({
  el: '#base',
  data() {
    return {
      isMobile: false,
    };
  },
  mounted() {
    const self = this;

    self.init();

    window.addEventListener('resize', () => {
      self.init();
    });

    window.addEventListener('orientationchange', () => {
      self.init();
    });
  },

  methods: {
    init() {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
      this.isMobile = window.innerWidth < 991.98;
    },
  },
});

$(document).ready(function() {
  $('.collapse').on('show.bs.collapse', function() {
    $('.nav-mobile').addClass('open');
  });
  $('.collapse').on('hidden.bs.collapse', function() {
    $('.nav-mobile').removeClass('open');
  });
});
